import React from 'react';
import { motion } from 'framer-motion';
import { FiCheckCircle, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const ThankYouPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] w-full px-6 text-center">
      <div className="max-w-2xl w-full mx-auto">
        <motion.div 
          initial={{ opacity: 0, scale: 0.8 }} 
          animate={{ opacity: 1, scale: 1 }} 
          className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mb-8 mx-auto border border-green-500/20"
        >
          <SafeIcon icon={FiCheckCircle} className="text-4xl text-green-500" />
        </motion.div>

        <motion.h1 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.1 }}
          className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight"
        >
          Vielen Dank für <br />
          <span className="text-brand-blue text-glow">dein Vertrauen!</span>
        </motion.h1>

        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.2 }}
          className="space-y-6"
        >
          <p style={{
      color: 'rgb(209, 213, 219)'
    }} className="text-xl text-gray-300 leading-relaxed">Dein Termin ist gebucht!</p>
          
          <div className="bg-brand-card/30 border border-brand-border rounded-2xl p-8 backdrop-blur-sm">
            <p className="text-gray-400 text-lg">
              Du bekommst gleich eine Bestätigung per Mail.
Bis zu unserem Gespräch eine Bitte:
              <br /><br />
              Überleg dir ehrlich, wo hängst du gerade wirklich fest?
Nicht was du nach außen sagst. Was tatsächlich nicht läuft.
Genau da fangen wir an.
            </p>
          </div>

          <Link 
            to="/geschaeftsfuehrer-video" 
            className="inline-flex items-center gap-2 text-brand-blue hover:text-white transition-colors mt-8 font-medium"
          >
            <SafeIcon icon={FiArrowLeft} /> Zurück zur Hauptseite
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default ThankYouPage;